export const env = {
  API_BASE_URL:
    window.__ENV__?.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL,
  API_KEY: window.__ENV__?.REACT_APP_API_KEY || process.env.REACT_APP_API_KEY,
};
